import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function getSessionId() {
  let id = sessionStorage.getItem("sd_sid");
  if (!id) {
    id = "s_" + Math.random().toString(36).slice(2, 12) + "_" + Date.now();
    sessionStorage.setItem("sd_sid", id);
  }
  return id;
}

async function post(evt) {
  try {
    await axios.post(`${API}/events`, evt, { timeout: 3000 });
  } catch (_) {
    // Fail silently — never break UX on analytics
  }
}

export function trackClick(label) {
  post({
    type: "click",
    path: window.location.pathname,
    referrer: document.referrer || null,
    session_id: getSessionId(),
    user_agent: navigator.userAgent,
    label,
  });
  // Also mirror to GA4 if available
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "cta_click", { event_label: label });
  }
}

export function usePageTracker() {
  const location = useLocation();
  const first = useRef(true);
  useEffect(() => {
    post({
      type: "page_view",
      path: location.pathname + location.search,
      referrer: first.current ? (document.referrer || null) : null,
      session_id: getSessionId(),
      user_agent: navigator.userAgent,
    });
    first.current = false;
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", { page_path: location.pathname });
    }
  }, [location.pathname, location.search]);
}
